import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { GatsbyImage } from "gatsby-plugin-image";
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';
import { useWindowSize } from 'rooks';

const InlineGraphic = (props) => {
  const { module } = props;
  const { anchorTagLinkText, images } = module;
  const { mobileImage, desktopImage } = images;
  const { innerWidth } = useWindowSize();
  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <section id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container className="inline-graphic">
        <Grid>
          <Grid.Row centered>
            <Grid.Column
              mobile={12}
              tablet={10}
              computer={largeMonitorContext ? 8 : 10}
              largeScreen={8}
            >
              {innerWidth > 767
                ? desktopImage &&
                  desktopImage.localFile &&
                  desktopImage.localFile.childImageSharp && (
                    <GatsbyImage
                      image={desktopImage.localFile.childImageSharp.gatsbyImageData}
                      className="inline-graphic__img"
                      alt={desktopImage.alt_text ? desktopImage.alt_text : ''} />
                  )
                : mobileImage &&
                  mobileImage.localFile &&
                  mobileImage.localFile.childImageSharp && (
                    <GatsbyImage
                      image={mobileImage.localFile.childImageSharp.gatsbyImageData}
                      className="inline-graphic__img"
                      alt={mobileImage.alt_text ? mobileImage.alt_text : ''} />
                  )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default InlineGraphic;
